<template>
  <div class=" tailor">
    <nav class="navbar navbar-dark bg-orange-custom sticky-top" >
      <a class="navbar-brand" href="#">Add New Issue <i class="fa fa-comment"></i></a>
      <a href="#" class="text-light" v-on:click="resetForm()" v-b-tooltip.hover title="Close">
        <i class="fas fa-2x fa-times-circle"></i>
      </a>
    </nav>
    <br>
    <div class="row container">
      <div class="col">
        Click the "Select Location" button and select a location in the map
        <button v-on:click="addNewIssueLayer()" class="btn btn-primary" title="Click to start adding issues">
        Select Location
        </button>
      </div>
    </div>
    <hr>
    <br>
    <template v-if="isLocationSelected">
      <div class="row container">
        <div class="col-6">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Issue No.</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="issueNo" type="text" disabled>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Organization</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedOrganization" required>
                <option value="" disabled selected></option>
                <option v-for="organization in organizationOptions"  :key="organization.id" :value="organization.code">{{organization.name}}</option>
              </select>
            </div>
          </div> -->
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Discipline</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedDiscipline" required>
                <option value="" disabled selected></option>
                <option v-for="discipline in disciplineOptions"  :key="discipline.id" :value="discipline.code">{{discipline.name}}</option>
                <!-- <option value="road_design">Road Design</option>
                <option value="bridge">Bridge</option>
                <option value="utility">Utility</option>
                <option value="drainage">Drainage</option>
                <option value="environment">Environment</option>
                <option value="ecology">Ecology</option>
                <option value="heritage">Heritage</option>
                <option value="geotechnical">Geotechnical</option> -->
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Addressed to</label>
            <div class="col-sm-8">
              <Multiselect
                v-model="addressedTo"
                :options="userFilteredList"
                group-values="users"
                group-label="organization"
                label="userEmail"
                track-by="userEmail"
                placeholder="Email"
                hide-selected
                multiple
                :taggable="true"
                @tag="addAddressedToTag"
                >
              </Multiselect>
            </div>
          </div>

        </div>
        <div class="col-6">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Created by</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="issueCreatedBy" type="text" disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Request Created</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="requestCreated" type="date" disabled>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">CC</label>
            <div class="col-sm-8">
              <Multiselect
                v-model="ccEmail"
                :options="userFilteredList"
                group-values="users"
                group-label="organization"
                label="userEmail"
                track-by="userEmail"
                placeholder="Email"
                hide-selected
                multiple
                :taggable="true"
                @tag="addCCEmailTag"
                >
              </Multiselect>
            </div>
          </div>
        </div>
      </div>
      <hr style="margin-top: 0;">
      <div class="row container">
        <div class="col-6">

          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Work Package</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedWorkPackage" required>
                <option value="" disabled selected></option>
                <option v-for="workPackage in workPackageOptions"  :key="workPackage.id" :value="workPackage.code">{{workPackage.name}}</option>
              </select>
            </div>
          </div> -->

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Type</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedType" required>
                <option value="" disabled selected></option>
                <option value="environment">Environment</option>
                <option value="constructability">Constructability</option>
                <option value="health_safety">Health & Safety</option>
                <option value="3d_model_issue">3D Model Issue</option>
                <option value="coordination">Coordination</option>
                <option value="design_issue">Design Issue</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Response Required by</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="responseRequiredBy" type="date" required>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Update by</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="updateBy" type="text" required>
            </div>
          </div> -->
        </div>
        <div class="col-6">

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Priority</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedPriority" required>
                <option value="" disabled selected></option>
                <option value="critical">Critical</option>
                <option value="major">Major</option>
                <option value="minor">Minor</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Status</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="approvalStatus" type="text" disabled>
            </div>
          </div>
        </div>
      </div>
      <div class="row container">
        <div class="col-12">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Request Details</label>
            <div class="col-sm-10">
              <textarea style="resize:none;" rows="3" class="form-control" v-model="textRequest" required></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">File Upload</label>
            <div class="col-sm-6">
              <b-form-file id="fileUpload"></b-form-file>
            </div>
          </div>
          <div class="text-right">
            <button v-on:click="submitNewIssueLayer()" class="btn btn-outline-primary mr-2" title="Click to submit issue">
              Submit
            </button>
            <button v-on:click="resetForm()"
              class="btn btn-outline-danger"
               title="Click to cancel">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/*eslint-disable*/
import { loadModules } from 'esri-loader';
import {baseApiUrl, appBaseUrl} from "../../config.js"
import axios from "axios"
import Multiselect from "vue-multiselect"

export default {
  name: 'NewIssue',
  components: {
    Multiselect
  },
  data () {
    return {
      userName: this.$store.state.mapModule.userName,
      IssueNo: "",
      textIssue: "",
      addressedTo: [],
      ccEmail: [],
      issueCreatedBy: this.$store.state.mapModule.user.fullName,
      requestCreated: "",
      responseRequiredBy: "",
      updateBy: "",
      selectedType: "",
      // selectedStatus: "pending",
      textRequest: "",
      selectedDiscipline: "",
      selectedPriority: "",
      selectedOrganization: "",
      selectedWorkPackage: "",
      dueDate: "",
      approvalStatus: "Pending",
      isLocationSelected: false,
      selectedEmail: [],
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      emails: [
        {
          value: "leonardo.quines@arcadis.com",
          label: "leonardo.quines@arcadis.com"
        },
        {
          value: "sheena.verdad@arcadis.com",
          label: "sheena.verdad@arcadis.com"
        },
        {
          value: "Rittick.Borah@arcadis.com",
          label: "Rittick.Borah@arcadis.com"
        },
        {
          value: "Nalin.Senevirathne@arcadis.com",
          label: "Nalin.Senevirathne@arcadis.com"
        }
      ],
      errorMsgDictionary: {
        noRequestDetailsFound: "Request Details field was left blank",
        noDisciplineFound: "Discipline field was left blank",
        noPriorityFound: "Priority field was left blank",
        noResponseRequiredByFound: "Response Required By field was left blank",
        noAddressedToFound: "Addressed To field was left blank",
        noIssueTypeFound: "Type field was left blank",
        noWorkPackageFound: "Work Package field was left blank"
      },
      newIssueGeometry: {
        longitude: null,
        latitude: null,
        z: null
      },
      disciplineOptions: {},
      organizationOptions: {},
      workPackageOptions: {},
      // userList: []
    }
  },
  computed: {
    issueLayerId: {
      get() {
        return this.$store.state.mapModule.staticIssueLayerId
      }
    },
    isAddNewIssue: {
      get() {
        return this.$store.state.mapModule.isAddNewIssue
      }
    },
    issueFeatureList: {
      get() {
        return this.$store.state.mapModule.initialIssues
      }
    },
    userList: {
      get() {
        return this.$store.state.mapModule.userList
      }
    },
    userFilteredList: {
      get() {
        var finalList = this.userList
        var newList = []
        console.log(this.addressedTo);
        if (this.selectedDiscipline != "") {
          // finalList = this.userList.users.filter(obj=>obj.disciplineCode == this.selectedDiscipline)
          // finalList = this.userList.filter( userListItem =>
          //     userListItem.user.filter( obj =>
          //         obj.disciplineCode == this.selectedDiscipline
          //     )
          // )

          // finalList = this.userList.filter(function(userListItem) {
          // 	return userListItem.user.filter(function(obj) {
          //   	return obj.disciplineCode == this.selectedDiscipline;
          //   });
          // });

          this.userList.forEach((userListItem) => {
            let filteredUser = {
                organization:userListItem.organization,
                users: []
            }

            userListItem.users.forEach((item) => {
              if(item.disciplineCode == this.selectedDiscipline){
                let userItem = {
                  userEmail:item.userEmail,
                  disciplineCode:item.disciplineCode
                }
                filteredUser.users.push(userItem)

              }

            });

            // if(this.selectedDiscipline != "gis" && userListItem.organization == "Arcadis"){
            // if(this.selectedDiscipline != "environment" && userListItem.organization == "Arcadis"){
            //   let usertest1 = {
            //     userEmail: 'leonardo.quines@arcadis.com',
            //     disciplineCode:this.selectedDiscipline
            //   }
            //   let usertest2 = {
            //     userEmail: 'sheena.verdad@arcadis.com',
            //     disciplineCode:this.selectedDiscipline
            //   }
            //   filteredUser.users.push(usertest1)
            //   filteredUser.users.push(usertest2)
            // }
            newList.push(filteredUser);
          });
          finalList = newList
          console.log(finalList);
        }

        return finalList
      }
    },
    currentUser: {
      get() {
        return this.$store.state.mapModule.user
      }
    },
  },
  methods: {
    addAddressedToTag: function (newTag) {
      console.log(newTag);
      const current = this
      const tag = {
        userEmail: newTag
      }
      // const tag = {
      //   organization: "New",
      //   users: [
      //     {
      //       disciplineCode: "",
      //       userEmail: newTag
      //     }
      //   ]
      // }
      if (current.reg.test(newTag)) {
        current.addressedTo.push(tag)
      }
      else {
        current.$notify({
          group: 'errors',
          title: "Error Adding Email",
          type: 'error',
          text: "Email entered is invalid.",
          width: 500,
          duration: 2000
        })
      }
    },
    addCCEmailTag: function (newTag) {
      console.log(newTag);
      const current = this
      const tag = {
        userEmail: newTag
      }
      // const tag = {
      //   organization: "",
      //   users: [
      //     {
      //       disciplineCode: "",
      //       userEmail: newTag
      //     }
      //   ]
      // }
      if (current.reg.test(newTag)) {
        current.ccEmail.push(tag)
      }
      else {
        current.$notify({
          group: 'errors',
          title: "Error Adding Email",
          type: 'error',
          text: "Email entered is invalid.",
          width: 500,
          duration: 2000
        })
      }
    },
    addNewIssueLayer: function() {
      const scene = this
      const vue = document.getElementById("map").__vue__
      const sceneView = vue.view
      const current = this
      sceneView.graphics.removeAll()
      loadModules([
        "dojo/on",
        "esri/Graphic"],{ css: true })
      .then(([
        on,
        Graphic]) => {
        var appMap = document.getElementById("map");
        appMap.style.cursor = "crosshair";
        var onceClick = on.once(sceneView, "click", (evt) => {
          if (appMap.style.cursor === "auto") {
            onceClick.remove();
            console.log("event listener removed");
            return;
          }
          sceneView.hitTest(evt).then((hitTestResult) => {
            if (hitTestResult.results.length) {
              var point = hitTestResult.results[0].mapPoint.clone()
            } else {
              var point = hitTestResult.ground.mapPoint.clone()
            }
            point.z = 0
            console.log(point);
            var newIssueEntry = new Graphic({
              geometry: point,
              attributes: {},
              symbol: {
                type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                url: "InitialMarker.png",
                width: 20
                // type: "point-3d",
                // symbolLayers: [{
                //   type: "object",
                //   anchor: "origin",
                //   width: 5,
                //   material: {
                //     color: [0, 132, 168, 1]
                //   }
                // }]
              }
            });
            sceneView.graphics.add(newIssueEntry);
            current.newIssueGeometry.longitude = point.longitude
            current.newIssueGeometry.latitude = point.latitude
            current.newIssueGeometry.z = point.z
            current.isLocationSelected = true
            appMap.style.cursor = "auto";
          })
        })
      })
    },
    saveValidation: function() {
      const current = this
      var errors = []
      if (current.selectedDiscipline == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Discipline"
        errorMessage.errorBody = current.errorMsgDictionary.noDisciplineFound
        errors.push(errorMessage)
      }
      if (current.addressedTo.length == 0) {
        var errorMessage = {}
        errorMessage.errorTitle = "Addressed To"
        errorMessage.errorBody = current.errorMsgDictionary.noAddressedToFound
        errors.push(errorMessage)
      }
      // if (current.selectedWorkPackage.length == 0) {
      //   var errorMessage = {}
      //   errorMessage.errorTitle = "Work Package"
      //   errorMessage.errorBody = current.errorMsgDictionary.noWorkPackageFound
      //   errors.push(errorMessage)
      // }
      if (current.responseRequiredBy == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Response Required By"
        errorMessage.errorBody = current.errorMsgDictionary.noResponseRequiredByFound
        errors.push(errorMessage)
      }
      if (current.selectedType == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Type"
        errorMessage.errorBody = current.errorMsgDictionary.noIssueTypeFound
        errors.push(errorMessage)
      }
      if (current.selectedPriority == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Priority"
        errorMessage.errorBody = current.errorMsgDictionary.noPriorityFound
        errors.push(errorMessage)
      }
      if (current.requestDetails == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Request Details"
        errorMessage.errorBody = current.errorMsgDictionary.noRequestDetailsFound
        errors.push(errorMessage)
      }
      return errors
    },
    submitNewIssueLayer: function() {
      const current = this
      const vue = document.getElementById("map").__vue__
      const sceneView = vue.view
      var errors = current.saveValidation();
      if (errors.length > 0) {
        errors.forEach(item=>{
          current.$notify({
            group: 'errors',
            title: item.errorTitle,
            type: 'error',
            text: item.errorBody,
            width: 500,
            duration: -1
          })
        })
      }
      else {
        var dateToday = current.getDateToday()
        var fileUploadDom = document.getElementById("fileUpload");
        // var issueSceneLayer = sceneView.map.allLayers.filter(function(item) {
        //   return item.id === current.issueLayerId;
        // }).items[0];
        var issueSceneLayer = sceneView.map.findLayerById(current.issueLayerId)
        var recipients = []
        current.selectedEmail.forEach(item => {
          recipients.push(item.value)
        })
        var addressedToEmail = []
        current.addressedTo.forEach(item => {
            addressedToEmail.push(item.userEmail)
        })
        var ccEmailAddress = []
        current.ccEmail.forEach(item => {
          ccEmailAddress.push(item.userEmail)
        })
        ccEmailAddress.push(current.currentUser.email)

        var data = {
          disciplineCode: current.selectedDiscipline,
          priorityCode: current.selectedPriority,
          organizationCode: current.selectedOrganization,
          workPackageCode: current.selectedWorkPackage,
          approvalStateCode: current.approvalStatus.toLowerCase(),
          longitude: current.newIssueGeometry.longitude,
          latitude: current.newIssueGeometry.latitude,
          elevation: current.newIssueGeometry.z,
          dueDate: current.dueDate,
          issueDetails: current.textIssue,
          addressedTo: addressedToEmail,
          ccEmail: ccEmailAddress,
          issueCreatedBy: current.$store.state.mapModule.user.email,
          requestCreated: current.requestCreated,
          responseRequiredBy: current.responseRequiredBy,
          updateBy: current.updateBy,
          issueTypeCode: current.selectedType,
          requestDetails: current.textRequest,
          recipients: recipients
        }
        var newIssueURL = baseApiUrl + "saveInitialIssue"
        var config  = {
          responseType: 'json'
        }
        axios.post(newIssueURL, data, config).then(response=>{
          // console.log(response);
          // query new Issue list
          sceneView.map.remove(issueSceneLayer);
          sceneView.map.allLayers.refresh()
          if(response.data.status == "success"){
            current.$store.dispatch("mapModule/fetchIssueLayer").then(currentIssueLayer=>{
              console.log("just fetched the new issue Layer");
              sceneView.map.add(currentIssueLayer);
              // sceneView.map.allLayers.remove(issueSceneLayer);
              console.log(sceneView.map.allLayers);
              // sceneView.graphics.removeAll()
              // sceneView.map.allLayers.add(currentIssueLayer);
              // console.log("before Refresh");
              // sceneView.map.allLayers.refresh()
              // console.log("after Refresh");

              console.log(sceneView.map.allLayers);

              console.log(currentIssueLayer);
              var latestIssue = currentIssueLayer.graphics.items[currentIssueLayer.graphics.items.length-1]
              // response.graphics.items.forEach(issue=>{
              var featureObject = {}
              featureObject["objectId"] = latestIssue.attributes.id
              // featureObject["globalId"] = latestIssue.attributes.globalid
              featureObject["discipline"] = latestIssue.attributes.discipline
              featureObject["priority"] = latestIssue.attributes.priority
              featureObject["createdBy"] = latestIssue.attributes.issueCreatedBy
              featureObject["userName"] = latestIssue.attributes.userName
              featureObject["addressedTo"] = latestIssue.attributes.addressedTo
              featureObject["issueType"] = latestIssue.attributes.issueType
              featureObject["requestDetails"] = latestIssue.attributes.requestDetails
              // featureObject["issue"] = latestIssue.attributes.details
              featureObject["approvalStatus"] = latestIssue.attributes.approvalState
              featureObject["date"] = latestIssue.attributes.date
              featureObject["requestCreated"] = latestIssue.attributes.requestCreated
              featureObject["responseRequiredBy"] = latestIssue.attributes.responseRequiredBy
              featureObject["updateBy"] = latestIssue.attributes.updateBy
              // featureObject["dueDate"] = latestIssue.attributes.dueDate

              // current.issueFeatureList.push(featureObject)
              // current.issueIds.push(item.attributes.id)
              // current.$store.commit("mapModule/insertInitialIssues", featureObject)
              // var fileUploadDom = document.getElementById("fileUpload");
              current.uploadAttachment(latestIssue.attributes.id).then(fileDetail=>{
                console.log("just finished uploading the attachent");
                if (fileDetail.hasFile) {
                  featureObject["fileName"] = fileDetail.fileName
                  featureObject["fileId"] = fileDetail.fileId
                }
                current.sendEmail(featureObject)
                current.$store.commit("mapModule/insertInitialIssues", featureObject)
                console.log(fileDetail);
                current.resetForm()
              })
            })
          }
          else if(response.data.status == "failed"){
            current.$notify({
              group: 'errors',
              title: "Failed to create issue",
              type: 'error',
              text: response.data.message,
              width: 500,
              duration: -1
            })
          }
        })
      }
    },
    resetForm: function() {
      const current = this
      var view =  document.getElementById("map").__vue__.view
      current.textIssue = ""
      current.selectedDiscipline = ""
      current.selectedPriority = ""
      current.dueDate = ""
      current.approvalStatus= "Pending"
      view.graphics.removeAll()
      document.getElementById("addIssueButton").click();
      current.newIssueGeometry = {
        longitude: null,
        latitude: null,
        z: null
      }
      current.$store.commit("mapModule/setIfAddNewIssueClicked", false)
      var map = document.getElementById("mapContainer")
      if (!current.isAddNewIssue) {
        map.classList.remove("col-6")
        map.classList.add("col-9")
      }
    },
    sendEmail: function(data) {
      const current = this
      var url = baseApiUrl + "sendEmail"

      var addressedToEmail = []
      current.addressedTo.forEach(item => {
          addressedToEmail.push(item.userEmail)
      })


      var ccEmailAddress = []
      current.ccEmail.forEach(item => {
        ccEmailAddress.push(item.userEmail)
      })
      ccEmailAddress.push(current.currentUser.email)

      var data = {
        addressedTo: addressedToEmail,
        ccEmail: ccEmailAddress,
        issueid: data.objectId,
        name: data.createdBy,
        issue: data.requestDetails,
        discipline: data.discipline,
        priority: data.priority,
        issueType: data.issueType,
        responseRequiredBy: data.responseRequiredBy,
        date: data.requestCreated,
        approvalstatus: data.approvalStatus,
        appBaseUrl: appBaseUrl
      }
      var config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        console.log(result.data);
      }).catch((error)=> {
        console.log(error);
      })
    },
    getDateToday: function() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let time = hours + ":" + minutes + ":" + seconds + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
    uploadAttachment: function(issueId) {
      return new Promise(function(resolve, reject) {
        var attachmentsSuccessfulCount = 0
        var fileUploadDom = document.getElementById("fileUpload");
        console.log(fileUploadDom);
        if (fileUploadDom.files.length === 1) {
          var fileURL = baseApiUrl + "addIssueAttachment"
          fileUploadDom.files.forEach(item=>{

            var fileData = new FormData();
            fileData.append("fileinput"       , item);
            fileData.append("issueId"       , issueId);
            fileData.append("filename"        , item.name);
            fileData.append("filetype"        , item.type);
            var fileConfig = {
              headers: {
                'content-type': 'application/octet-stream'
              },
              responseType: 'json'
            }
            axios.post(fileURL, fileData, fileConfig).then(fileResult=>{
              // result.data.commentAttachments.push(fileResult.data)
              fileResult.data.hasFile = true
              resolve(fileResult.data)
              // attachmentsSuccessfulCount+=1
              // if (attachmentsSuccessfulCount==current.commentAttachments.length) {
              // }
            })
            .catch(error=>{
              console.log(error);
            })
          })
        }
        else {
          resolve(
            {
              hasFile:false
            }
          )
        }

      });
    },
    getDisciplines: function() {
      const current = this
      current.disciplineOptions = {}
      let url = baseApiUrl + "fetchDisciplines"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result);
        current.disciplineOptions = result.data
      })
    },
    getOrganizations: function() {
      const current = this
      current.organizationOptions = {}
      let url = baseApiUrl + "fetchOrganizations"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result);
        current.organizationOptions = result.data
      })
    },
    getWorkPackages: function() {
      const current = this
      current.workPackageOptions = {}
      let url = baseApiUrl + "fetchWorkPackages"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result);
        current.workPackageOptions = result.data
      })
    },
    getUsers: function() {
      const current = this
      // current.userList = {}
      let url = baseApiUrl + "fetchUsers"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result.data);
        // current.userList = result.data
        current.$store.commit("mapModule/insertUserList", result.data)
        // current.emails
      })
    }
  },
  mounted() {
    const current = this
    current.requestCreated = new Date().toISOString().substring(0,10);

    current.issueNo = current.issueFeatureList.length == 0 ? "1":current.issueFeatureList[current.issueFeatureList.length - 1].objectId + 1
    current.getDisciplines()
    current.getOrganizations()
    current.getWorkPackages()
    current.getUsers()
    console.log(current.disciplineOptions);
    console.log(current.userList);
  }

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .tailor {
    height: 912px;
    max-height: 99%;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .multiselect__tag {
    background: gray !important;
    color: white !important;
  }
  .multiselect__tag-icon {
    background: gray !important;
    color: white !important;
  }
  .multiselect__tag-icon:after {
    color: white !important;
  }
  .multiselect__option--highlight {
    background: gray !important;
    outline: none;
    color: white;
  }
  .multiselect__option--highlight:after {
    background: gray !important;
  }
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px;
  }
</style>
